/** Shared media-query hook. Not part of the public components/README.md list. */
import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false));

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** DS breakpoint: below --pl-bp-tablet (768px) is "phone" throughout Pleach. */
export function useIsPhone(): boolean {
  return useMediaQuery('(max-width: 767px)');
}
